import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { hasPerm, scopeActive } from "./lib/format";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import StaffDashboard from "./pages/StaffDashboard";
import Upload from "./pages/Upload";
import UploadHistory from "./pages/UploadHistory";
import Users from "./pages/Users";
import Staff from "./pages/Staff";
import Templates from "./pages/Templates";
import Settings from "./pages/Settings";
import DataManagement from "./pages/DataManagement";

function Loading() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-300 border-t-blue-700" />
    </div>
  );
}

function Protected({ children, perm, role }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (perm && !hasPerm(user, perm)) return <Navigate to="/" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}

function DashboardRouter() {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (hasPerm(user, "view_overall_dashboard")) return <Dashboard />;
  if (user.role === "staff" || user.salesman_name) return <StaffDashboard />;
  if (hasPerm(user, "view_store_metrics") || scopeActive(user.floor_target_scope) || scopeActive(user.incentive_scope)) return <StaffDashboard />;
  if (hasPerm(user, "upload_data")) return <Navigate to="/upload" replace />;
  return <StaffDashboard />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Protected><DashboardRouter /></Protected>} />
      <Route path="/upload" element={<Protected perm="upload_data"><Upload /></Protected>} />
      <Route path="/history" element={<Protected perm="view_upload_history"><UploadHistory /></Protected>} />
      <Route path="/users" element={<Protected perm="manage_users"><Users /></Protected>} />
      <Route path="/staff" element={<Protected perm="manage_staff"><Staff /></Protected>} />
      <Route path="/templates" element={<Protected perm="manage_templates"><Templates /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="/data-management" element={<Protected role="admin"><DataManagement /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
